<template>
  <v-container
    id="resellers"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-shopping"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Resellers
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          class="px-2 ml-1"
          color="success"
          @click="gotoNew()"
        >
          New reseller
        </v-btn>
        <debounce-v-btn
          class="px-2 ml-1 v-btn--tight"
          color="info"
          @click="refreshResellers()"
        >
          Refresh
        </debounce-v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="resellers"
        :search.sync="search"
        :sort-desc="[false, false]"
        multi-sort
        class="row-action"
      >
        <template v-slot:item="{ item }">
          <tr @click="gotoDetails(item)">
            <td>
              <v-btn
                class="px-2 ml-1"
                color="warning"
                rounded
                small
                @click.stop="gotoDetails(item)"
              >
                Edit
              </v-btn>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.countryCode }}</td>
            <td>
              <v-btn
                v-if="item.uid !== $store.state.admin.resellerContext && item.uid !== $store.state.security.user.profile.ResellerId"
                class="px-2 ml-1"
                color="primary"
                rounded
                small
                @click.stop="setResellerContext(item)"
              >
                Connect as
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          width: '80px',
        },
        {
          sortable: true,
          text: 'Name',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Country',
          value: 'country',
        },
        {
          sortable: false,
          text: '',
          width: '80px',
        },
      ],
      search: '',
    }),
    computed: {
      resellers () {
        return this.$store.state.resellers.list
      },
    },
    created: function () {
      if (this.$store.state.resellers.list.length === 0) {
        this.refreshResellers()
      }
    },
    methods: {
      async refreshResellers () {
        this.$store.dispatch('RefreshResellers')
      },
      gotoDetails (item) {
        this.$router.push({ name: 'Reseller', params: { resellerUid: item.uid } })
      },
      gotoNew () {
        this.$router.push({ name: 'Reseller' })
      },
      setResellerContext (item) {
        this.$store.dispatch('SetResellercontext', item.uid)
      },
    },
  }
</script>
